import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=0253b178&scoped=true&"
import script from "./Warranty.vue?vue&type=script&lang=js&"
export * from "./Warranty.vue?vue&type=script&lang=js&"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=0253b178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253b178",
  null
  
)

export default component.exports